import React, { useEffect, useState } from 'react';
import OrderListPresenter from './OrderListPresenter';
// import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  useGetOrders,
  useUpdateOrder,
  useUpdateStatusOrder,
  orderQueryKeys,
} from 'hooks/OrderHooks';
import { useGetUsers } from 'hooks/UserHooks';
import { useCreateRefundOrder } from 'hooks/RefundHooks';
import { usePaymentCancelCard } from 'hooks/PaymentHooks.';
import MessageAlert, { PAYMENT_STORE_ID } from 'utils';
import { LoadingPage } from 'components';
import { useUserStack } from 'store';
import SubscriptionManager, { registerDevice } from 'utils/SubscriptionManager';
import moment from 'moment';
import { useQueryClient } from '@tanstack/react-query';

const OrderListContainer = (props) => {
  // // 오늘 날짜의 시작 (00:00:00)과 끝 (23:59:59) 타임스탬프 계산
  // const startOfToday = moment().startOf('day').unix();
  // const endOfToday = moment().endOf('day').unix();

  // 초기 오늘 날짜(시작, 종료) 및 포맷 정의
  const initialStart = React.useMemo(() => moment().startOf('day').unix(), []);
  const initialEnd = React.useMemo(() => moment().endOf('day').unix(), []);
  const MOMENT_FORMAT = 'YYYY-MM-DD(dddd)';
  // const initialTodayStr = moment().format(MOMENT_FORMAT);

  // 날짜 관련 상태 (선택된 날짜, 조회 범위, 화면에 표시할 날짜)
  const [selectedDate, setSelectedDate] = useState(moment());
  const [startOfDay, setStartOfDay] = useState(initialStart);
  const [endOfDay, setEndOfDay] = useState(initialEnd);
  // const [today, setToday] = useState(initialTodayStr);

  /* ===== ROUTE ===== */

  /* ===== PROPS ===== */

  /* ===== Mutate ===== */
  const queryClient = useQueryClient();
  const { updateStatusOrder } = useUpdateStatusOrder();
  const { createRefundOrder } = useCreateRefundOrder();
  const { updateOrder } = useUpdateOrder();
  const { cancelCard } = usePaymentCancelCard();
  const userInfo = useUserStack();

  /* ===== Data ===== */
  // const { data: Orders, refetch } = useGetOrders();
  const { data: Orders, refetch } = useGetOrders({
    start_date: startOfDay,
    end_date: endOfDay,
  });
  const { data: Users } = useGetUsers();

  /* ===== STATE ===== */
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [originData, setOriginData] = useState([]);
  const [subToken, setSubToken] = useState();
  const [isOpened, setIsOpened] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalType, setModalType] = useState('read');
  const [tabKey, setTabKey] = useState('all');
  const [filterKey, setFilterKey] = useState('ALL');

  /* ===== FUNCTION ===== */
  // 날짜 이동 함수 (좌/우, 오늘로)
  const handleChangeDay = (type = 'prev') => {
    let newDate = selectedDate.clone();
    if (type === 'today') {
      newDate = moment();
    } else if (type === 'prev') {
      newDate = newDate.subtract(1, 'days');
    } else if (type === 'next') {
      newDate = newDate.add(1, 'days');
    }
    setSelectedDate(newDate);
    // setToday(newDate.format(MOMENT_FORMAT));
    setStartOfDay(newDate.clone().startOf('day').unix());
    setEndOfDay(newDate.clone().endOf('day').unix());
  };

  /**
   * 상위 탭 필터링 핸들러
   */
  const handleFilterKey = (key) => {
    setFilterKey(key);
  };

  /**
   * 탭키 핸들러
   * --
   */
  const handleTabKey = (key) => {
    // navigate(`/order?status=${key}`);
    setTabKey(key);
    // setSelectedKeys(`order-${key}`);
  };

  /**
   * 주문 상태 업데이트
   * --
   */

  const handleUpdateOrder = async (
    order_route,
    order_id,
    order_status,
    payment_info = null,
    reason = null
  ) => {
    // console.log('order_route', order_route);
    // console.log('order_status', order_status);
    // console.log('Refund Reason:', reason);
    // console.log('payment_info', payment_info);
    // console.log('PAYMENT_STORE_ID', PAYMENT_STORE_ID);
    // return;
    if (order_route === 'APP' && order_status === 'CANCELLED') {
      try {
        setIsLoading(true);
        /**
         * 제이엠페이 주문 취소
         */
        if (!payment_info) {
          const cancelData = {
            order_id: order_id,
            refund_reason: reason,
          }
          const { status } = await createRefundOrder(cancelData);
          if (status !== 200) {
            MessageAlert.info("주문을 취소 할 수 없습니다.");
            return;
          };
          MessageAlert.success("성공적으로 주문상태가 변경되었습니다.");
          setModalData((prev) => ({ ...prev, t: {} }));
          setIsOpened(false);
          await refetch();
          return;
        };

        const { trno } = payment_info;

        const paymentCancelData = {
          mid: PAYMENT_STORE_ID,
          cancelType: 'FULL', // FULL(전체 취소) / PARTIAL(부분 취소)
          orgTradeKeyType: 'TID', // TID(결제 응답으로 부여받은 tid값) / ORDER_NUMB(결제 요청 시 생성한 가맹점 주문번호)
          orgTradeKey: trno,
        };

        const { data: cancelResponse } = await cancelCard(paymentCancelData);

        if (cancelResponse.code !== 'A0200') {
          MessageAlert.info('주문을 취소 할 수 없습니다.');
          return;
        }

        const { status } = await createRefundOrder({
          order_id,
          order_status,
          refund_reason: reason,
        });

        if (status === 200) {
          MessageAlert.success(`성공적으로 주문상태가 변경되었습니다.`);
          setModalData((prev) => ({ ...prev, t: {} }));
          setIsOpened(false);
          await refetch();
        } else {
          MessageAlert.warning(`주문상태를 변경하는데 실패하였습니다.`);
        }
      } catch (err) {
        MessageAlert.error(`주문상태를 변경하는데 오류가 발생하였습니다.`);
        console.error(`[Update] ORDER / ERROR : `, err);
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        setIsLoading(true);
        const { status } = await updateStatusOrder({ order_id, order_status });

        if (status === 200) {
          MessageAlert.success(`성공적으로 주문상태가 변경되었습니다.`);
          setModalData((prev) => ({ ...prev, t: {} }));
          setIsOpened(false);
          await refetch();
        } else {
          MessageAlert.warning(`주문상태를 변경하는데 실패하였습니다.`);
        }
      } catch (err) {
        MessageAlert.error(`주문상태를 변경하는데 오류가 발생하였습니다.`);
        console.error(`[Update] ORDER / ERROR : `, err);
      } finally {
        setIsLoading(false);
      }
    }
  };
  /**
   * 모달창 핸들러
   * --
   */
  const handleModalOpen = (data = {}) => {
    setModalData(data);
    setIsOpened(!isOpened);
  };

  /**
   * 결제상태 변경
   * --
   * @param {number} idx
   * @param {string} state [COMPLETED | REFUNDED]
   */
  const handleUpdatePaymentState = async (idx, state) => {
    if (!idx || !state) return;

    const confirm = window.confirm(
      `결제상태를 정말 변경하시겠습니까?\n결제 상태 변경 시 매출에 집계되지 않을 수 있습니다.`
    );

    if (!confirm) return;

    try {
      const { status } = await updateOrder({
        order_id: idx,
        payment_state: state,
      });

      if (status !== 200) {
        MessageAlert.info('결제상태 변경에 실패하였습니다!');
        return;
      }

      setModalData((prev) => ({
        ...prev,
        payment_state: state,
      }));

      // NOTE: 데이터 최신화
      const queryKey = orderQueryKeys.getOrders({
        start_date: startOfDay,
        end_date: endOfDay,
      });
      queryClient.invalidateQueries({
        queryKey: queryKey.queryKey,
      });

      MessageAlert.success('결제가 상태가 변경되었습니다.');
    } catch (err) {
      MessageAlert.error('결제 상태 변경에 실패하였습니다!');
      console.error('[handleUpdatePaymentState] Error!! ', err);
    }
  };

  /* ===== HOOKS ===== */

  // filterKey 변경 시 날짜를 오늘로 초기화
  useEffect(() => {
    const todayMoment = moment();
    setSelectedDate(todayMoment);
    // setToday(todayMoment.format(MOMENT_FORMAT));
    setStartOfDay(todayMoment.startOf('day').unix());
    setEndOfDay(todayMoment.endOf('day').unix());
  }, [filterKey]);
  /**
   * 모달 타입 초기화
   * --
   */
  useEffect(() => {
    if (!isOpened) setModalType('read');
  }, [isOpened]);

  /**
   * 구독 설정
   * --
   */

  const handleRegisterDevice = async (subscribe) => {
    try {
      await registerDevice(subscribe, subToken, userInfo);
      // 모든 작업이 완료된 후 페이지 리로드
      window.location.reload();
    } catch (error) {
      console.error('Device 등록 실패:', error);
    }
  };

  /**
   * 데이터 초기화
   * --
   */
  /**
   * 데이터 초기화
   * --
   */
  const computedOrders = React.useMemo(() => {
    // Users 데이터에서 user_id를 기준으로 사용자 정보를 추가
    const userMap = Users?.data?.reduce((acc, user) => {
      acc[user.user_id] = user;
      return acc;
    }, {});

    const originOrders = Orders?.data
      ?.filter(
        (item) =>
          item?.shop_information_id === userInfo?.shop_information_id &&
          item?.payment_state &&
          ['COMPLETED', 'REFUNDED'].includes(item.payment_state)
      )
      ?.map((order) => ({
        ...order,
        user: userMap?.[order?.user_id] || {},
        order_status: order?.order_status,
        menu: order?.product_information?.map((menuItem) => ({
          menu_name: menuItem.menu_name,
          num: menuItem.num,
          price: menuItem.price,
          option: menuItem.menu_option?.map((option) => ({
            option_id: option.option_id,
            option_title: option.option_title,
            option_type: option.option_type,
            option: option.option?.map((opt) => ({
              option_key: opt.option_key,
              option_name: opt.option_name,
              option_type: opt.option_type,
              option_price: opt.option_price,
              count: opt.count,
              default: opt.default,
            })),
          })),
        })),
        payment_date: new Date(order?.payment_completion_date * 1000),
        discount: order?.final_discount,
        totalPrice: order?.final_price,
        type: order?.type,
      }));

    const newData = Orders?.data
      ?.filter(
        (item) =>
          item?.shop_information_id === userInfo?.shop_information_id &&
          item?.payment_state &&
          ['COMPLETED', 'REFUNDED'].includes(item.payment_state) &&
          // NOTE: 당일 주문만 표시
          item?.payment_completion_date >= startOfDay &&
          item?.payment_completion_date <= endOfDay
      )
      ?.map((order) => ({
        ...order,
        user: userMap?.[order?.user_id] || {},
        order_status: order?.order_status,
        menu: order?.product_information?.map((menuItem) => ({
          menu_name: menuItem.menu_name,
          num: menuItem.num,
          price: menuItem.price,
          option: menuItem.menu_option?.map((option) => ({
            option_id: option.option_id,
            option_title: option.option_title,
            option_type: option.option_type,
            option: option.option?.map((opt) => ({
              option_key: opt.option_key,
              option_name: opt.option_name,
              option_type: opt.option_type,
              option_price: opt.option_price,
              count: opt.count,
              default: opt.default,
            })),
          })),
        })),
        payment_date: new Date(order?.payment_completion_date * 1000),
        discount: order?.final_discount,
        totalPrice: order?.final_price,
        type: order?.type,
      }));

    // filterKey에 따라 상위 탭 필터링
    const filteredOrders =
      filterKey === 'ALL'
        ? newData
        : filterKey === 'REFUNDED'
          ? originOrders?.filter((item) => item?.payment_state === filterKey)
          : filterKey === 'ALLORDER'
            ? originOrders
            : newData?.filter((item) => item?.order_route === filterKey);

    // 최신순 정렬 (payment_date 기준 내림차순 정렬)
    const sortedOrders = filteredOrders?.sort(
      (a, b) => b?.payment_date - a?.payment_date
    );

    return { sortedOrders, originOrders };
  }, [Orders, Users, filterKey, startOfDay, endOfDay, userInfo]);

  // useEffect(() => {
  //   // Users 데이터에서 user_id를 기준으로 사용자 정보를 추가
  //   const userMap = Users?.data?.reduce((acc, user) => {
  //     acc[user.user_id] = user;
  //     return acc;
  //   }, {});

  //   const originOrders = Orders?.data
  //     ?.filter(
  //       (item) =>
  //         item?.shop_information_id === userInfo?.shop_information_id &&
  //         item?.payment_state &&
  //         ['COMPLETED', 'REFUNDED'].includes(item.payment_state)
  //     )
  //     ?.map((order) => ({
  //       ...order,
  //       user: userMap?.[order?.user_id] || {},
  //       order_status: order?.order_status,
  //       menu: order?.product_information?.map((menuItem) => ({
  //         menu_name: menuItem.menu_name,
  //         num: menuItem.num,
  //         price: menuItem.price,
  //         option: menuItem.menu_option?.map((option) => ({
  //           option_id: option.option_id,
  //           option_title: option.option_title,
  //           option_type: option.option_type,
  //           option: option.option?.map((opt) => ({
  //             option_key: opt.option_key,
  //             option_name: opt.option_name,
  //             option_type: opt.option_type,
  //             option_price: opt.option_price,
  //             count: opt.count,
  //             default: opt.default,
  //           })),
  //         })),
  //       })),
  //       payment_date: new Date(order?.payment_completion_date * 1000),
  //       discount: order?.final_discount,
  //       totalPrice: order?.final_price,
  //       type: order?.type,
  //     }));

  //   const newData = Orders?.data
  //     ?.filter(
  //       (item) =>
  //         item?.shop_information_id === userInfo?.shop_information_id &&
  //         item?.payment_state &&
  //         ['COMPLETED', 'REFUNDED'].includes(item.payment_state) &&
  //         // NOTE: 당일 주문만 표시
  //         item?.payment_completion_date >= startOfDay &&
  //         item?.payment_completion_date <= endOfDay
  //     )
  //     ?.map((order) => ({
  //       ...order,
  //       user: userMap?.[order?.user_id] || {},
  //       order_status: order?.order_status,
  //       menu: order?.product_information?.map((menuItem) => ({
  //         menu_name: menuItem.menu_name,
  //         num: menuItem.num,
  //         price: menuItem.price,
  //         option: menuItem.menu_option?.map((option) => ({
  //           option_id: option.option_id,
  //           option_title: option.option_title,
  //           option_type: option.option_type,
  //           option: option.option?.map((opt) => ({
  //             option_key: opt.option_key,
  //             option_name: opt.option_name,
  //             option_type: opt.option_type,
  //             option_price: opt.option_price,
  //             count: opt.count,
  //             default: opt.default,
  //           })),
  //         })),
  //       })),
  //       payment_date: new Date(order?.payment_completion_date * 1000),
  //       discount: order?.final_discount,
  //       totalPrice: order?.final_price,
  //       type: order?.type,
  //     }));

  //   // filterKey에 따라 상위 탭 필터링
  //   const filteredOrders =
  //     filterKey === 'ALL'
  //       ? newData
  //       : filterKey === 'REFUNDED'
  //       ? originOrders?.filter((item) => item?.payment_state === filterKey)
  //       : filterKey === 'ALLORDER'
  //       ? originOrders
  //       : newData?.filter((item) => item?.order_route === filterKey);

  //   // 최신순 정렬 (payment_date 기준 내림차순 정렬)
  //   const sortedOrders = filteredOrders?.sort(
  //     (a, b) => b?.payment_date - a?.payment_date
  //   );

  //   setData(sortedOrders);
  //   setOriginData(originOrders);
  //   // eslint-disable-next-line
  // }, [Orders, Users, filterKey, startOfDay, endOfDay, userInfo]);

  // Orders 데이터가 업데이트되면(isLoading 상태가 true인 상태에서) 로딩 해제
  useEffect(() => {
    setIsLoading(true);
    if (Orders && Orders.data) {
      setIsLoading(false);
    }
  }, [Orders]);
  // console.log('Orders', Orders);
  // console.log('@@@@@@@@@@@@@@@@@@@@@@');
  // console.log(data);
  /* ===== RENDER ===== */

  return (
    <>
      {isLoading && (
        <LoadingPage text={'데이터를 처리중입니다. 잠시만 기다려주세요.'} />
      )}
      <SubscriptionManager
        subToken={subToken}
        setSubToken={setSubToken}
        onMessageReceived={refetch}
      />

      <OrderListPresenter
        data={computedOrders?.sortedOrders ?? []}
        originData={computedOrders?.originOrders ?? []}
        tabKey={tabKey}
        filterKey={filterKey} // 상위 탭 필터링 키 추가
        userInfo={userInfo}
        isOpened={isOpened}
        modalData={modalData}
        modalType={modalType}
        onModalChange={setModalType}
        onClose={handleModalOpen}
        onSelect={handleTabKey}
        onFilterSelect={handleFilterKey} // 상위 탭 필터링 핸들러 추가
        onSubmit={handleUpdateOrder}
        onDevice={handleRegisterDevice}
        // isRefetch={isRefetch}
        // setIsRefetch={setIsRefetch}
        // today={today}
        onChangeDay={handleChangeDay}
        // 전달 시 조회 범위도 함께 (Presenter에서 날짜 범위 표시 등에 활용)
        MOMENT_FORMAT={MOMENT_FORMAT}
        startOfToday={startOfDay}
        endOfToday={endOfDay}
        setStartOfDay={setStartOfDay}
        setEndOfDay={setEndOfDay}
        onUpdatePaymentState={handleUpdatePaymentState}
      />
    </>
  );
};

export default OrderListContainer;
